import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s from '../../components/ExchangeSidebar/exchangeSidebar.module.css';
import ButtonMenu from '../ButtonMenu';
import SidebarSectionTitle from '../SidebarSectionTitle/SidebarSectionTitle';
import { ActionTypes } from '../../constants/enums';

const mapStateToProps = ({ claims: { enabled: claimsEnabled } = {}, language }) => ({
  claimsEnabled,
  language,
});

const ProductOptionsMenu = ({
  claimsEnabled,
  language,
  options,
  inventoryError,
  onClick,
  checkSelected,
  disabled,
}) => (
  <div>
    <SidebarSectionTitle
      index={0}
      title={
        claimsEnabled
          ? language['returns.step_1.item_sidepanel_product_choice']
          : language['returns.step_1.sidepanel_product_choice']
      }
    />
    {inventoryError && (
      <div className={`${s.error_message} ${s.inventory_error}`}>
        {language['returns.step_1.sidepanel_inventory_error']}
      </div>
    )}
    <ButtonMenu
      menuItems={options}
      itemKey="type"
      propName="displayName"
      itemClick={onClick}
      checkSelected={checkSelected}
      disabled={disabled}
    />
  </div>
);

ProductOptionsMenu.defaultProps = {
  inventoryError: false,
  checkSelected: () => true,
  disabled: false,
};

ProductOptionsMenu.propTypes = {
  claimsEnabled: PropTypes.bool.isRequired,
  language: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf([ActionTypes.Return, ActionTypes.Exchange, ActionTypes.Claim]),
      displayName: PropTypes.string.isRequired,
    }),
  ).isRequired,
  inventoryError: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  checkSelected: PropTypes.func,
  disabled: PropTypes.bool,
};

export default connect(mapStateToProps)(ProductOptionsMenu);
